import { postTakeApartOrder } from "../../request/designapi/design/softwareOneKey/takeApartOrder/post.js";
async function postTakeApartOrderData(params) {
  const res = await postTakeApartOrder(params);
  if (res.status) {
    return res.data;
  } else {
    throw new Error(res.message);
  }
}
export { postTakeApartOrderData };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/kujiale/getCreateOrderFileTask.js